import React from 'react';

function RoundedPagination({ rowCount, rowsPerPage, currentPage, onChangePage }) {
  const totalPages = Math.max(1, Math.ceil(rowCount / rowsPerPage));
  const startRow = rowCount === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1;
  const endRow = Math.min(currentPage * rowsPerPage, rowCount);

  const windowSize = 5;
  let start = Math.max(1, currentPage - Math.floor(windowSize / 2));
  const end = Math.min(totalPages, start + windowSize - 1);
  start = Math.max(1, end - windowSize + 1);
  const pageNumbers = [];
  for (let p = start; p <= end; p += 1) pageNumbers.push(p);

  return (
    <div className="tp-pagination">
      <span>Showing {startRow} to {endRow} of {rowCount} rows</span>
      <div className="tp-pagination-buttons">
        <button type="button" className="tp-pagination-btn" disabled={currentPage === 1} onClick={() => onChangePage(1)}>«</button>
        <button type="button" className="tp-pagination-btn" disabled={currentPage === 1} onClick={() => onChangePage(currentPage - 1)}>‹</button>
        {pageNumbers.map(p => (
          <button
            key={p}
            type="button"
            className={`tp-pagination-btn${p === currentPage ? ' active' : ''}`}
            onClick={() => onChangePage(p)}
          >
            {p}
          </button>
        ))}
        <button type="button" className="tp-pagination-btn" disabled={currentPage === totalPages} onClick={() => onChangePage(currentPage + 1)}>›</button>
        <button type="button" className="tp-pagination-btn" disabled={currentPage === totalPages} onClick={() => onChangePage(totalPages)}>»</button>
      </div>
    </div>
  );
}

export default RoundedPagination;
